import {
    Box,
    Card,
    CardContent,
    Container,
    Typography
} from '@mui/material';
// import { useTheme } from '@mui/material/styles';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEmployees, getToken } from '../../utils/getData.js';
import getConsentId from '../../utils/getConsentId.js'

const SignInPage = () => {

    const navigate = useNavigate();
    const [clientId] = useState(getConsentId());

    const loginWithGoogle = useCallback(async (response) => {
        try {
            await getToken(response, navigate)
        } catch (e) {
            console.error('Error', e)
        }
    }, [navigate])

    const updatePullStateEmployees = async () => {
        try {
            await getEmployees()
        } catch (e) {
            console.error('Error', e)
        }
    }

    useEffect(() => {
        updatePullStateEmployees()
    }, [])

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: '100vh',
                    justifyContent: 'center',
                }}
            >
                <Card sx={{ width: '100%', maxWidth: 400, p: 3, backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'white', borderColor: 'white' }}>
                    <CardContent>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >

                            <img style={{ width: '10rem', height: 'auto', marginBottom: '1rem' }} src="https://images.squarespace-cdn.com/content/v1/562af2bee4b094a1579b7245/1510334525983-3D9G5SP3INR4JF4YRGCO/etro_white.png?format=1500w" />

                            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3, color: 'white' }}>
                                Welcome user, please sign in to continue.
                            </Typography>

                            <GoogleOAuthProvider clientId={clientId}>
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <GoogleLogin
                                        onSuccess={loginWithGoogle}
                                        onError={() => console.log('Manual Login Failed')}
                                        useOneTap={false}
                                        auto_select={false}
                                        theme="outline"
                                        size="large"
                                        width="300"
                                    />
                                </Box>
                            </GoogleOAuthProvider>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    )
}

export default SignInPage
